module.exports = __webpack_public_path__ + "img/D&D-Elemente_Dreieck_Kapitel4.e953f7e0.svg";